import React from "react";
import { isAndroid, isIOS, osName, isSafari } from "react-device-detect";
import GBETNativeInterface from "../../libs/gbetnativeinterface";

class NativeDownloader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPanel: ((isIOS && GBEglobal.settings.nativeAppSettings.ios && isSafari) || (isAndroid && GBEglobal.settings.nativeAppSettings.android))
        };
        //GBEUtils.getCookie("knowsNativeApp") === ""
        this.dismiss = this.dismiss.bind(this);
    }

    dismiss() {
        GBEUtils.setCookie("knowsNativeApp", true, null, "None;Secure");
        this.setState({
            showPanel: false
        });
    }

    render() {

        if (!this.state.showPanel) {
            return (<></>);
        }
        const inStore = ((isIOS && (GBEglobal.settings.nativeAppSettings.ios.indexOf("itunes.apple.com") > -1) || isIOS && GBEglobal.settings.nativeAppSettings.ios.indexOf("apps.apple.com") > -1))
            || (isAndroid && GBEglobal.settings.nativeAppSettings.android.indexOf("play.google.com") > -1);
        const iconClass = "icon " + osName.toLowerCase() + (inStore ? " instore" : " nonstore");

        const keySuffix = isIOS ? "ios" : "android";

        const downloadUrl = GBEglobal.settings.nativeAppSettings[keySuffix + "_" + configurationSettings.mode] || GBEglobal.settings.nativeAppSettings[keySuffix];

        if (GBETNativeInterface.isAndroidWebView || GBETNativeInterface.isWKWebView) {
            return;
        }

        return (
            <div className="native-downloader row">
                <div className={"col-1"}></div>
                <div className={"col-5"}>
                    {isIOS &&
                        <a href={downloadUrl}>Download {configurationSettings.whitelabelDisplayName} for IOS</a>
                    }
                    {isAndroid &&
                        <a href={downloadUrl}>Download {configurationSettings.whitelabelDisplayName} for Android</a>
                    }
                </div>
                <div className={"col-5"} style={{ "textAlign": "center" }}>
                    <a href={downloadUrl} className={iconClass} ></a>
                </div>
                <div className={"col-1"}></div>
                <div className="col-2 d-none">
                    <button className="brn btn-secondary" onClick={this.dismiss}>X</button>
                </div>
            </div >
        );
    }
}

export { NativeDownloader };